import { useCallback, useEffect, useRef, useState } from "react"
import { getTableWeeksProjects } from "../../../../config";
import useYear from "../../../../hooks/Year";
import { getColumns } from "../util/column";
import { getFormatedCSV, getLineChart, getTotalWeeks } from "../util/tableWeek";

const useTableWeeks = () => {
    const { listOfYears, updateYear, year } = useYear(5);

    const [loading, setLoading] = useState(false)
    const [sectionMenu, setSectionMenu] = useState(0)
    const [columns, setColumns] = useState([])

    const [stateWeeks, setStateWeeks] = useState({
        tableData: [],
        totalsWeeks: {
            weeksEstimate: 0,
            weeksWorked: 0,
            difference: 0,
        },
        csv: [],
        lineChart: []
    })
    const buttonCSV = useRef(null)

    const downloadCSV = () => buttonCSV.current.link.click();

    const handleSectionChange = (section) => setSectionMenu(section)

    const onChangeTable = (pagination, filters, sorter, extra = { action: "", currentDataSource: [] }) => {
        const { action, currentDataSource } = extra;
        if (action === "filter") {
            setStateWeeks(prev => ({
                ...prev,
                totalsWeeks: getTotalWeeks(currentDataSource),
                csv: getFormatedCSV(currentDataSource),
                lineChart: getLineChart(currentDataSource)
            }))
        }
    };

    const getTableWeeks = useCallback(
        () => {
            setLoading(true)
            getTableWeeksProjects(year)
                .then((res) => {
                    if (res.status !== 0) return
                    const { weeks, filters } = res.payload
                    setColumns(getColumns(filters))
                    setStateWeeks({
                        tableData: weeks,
                        totalsWeeks: getTotalWeeks(weeks),
                        csv: getFormatedCSV(weeks),
                        lineChart: getLineChart(weeks)
                    })
                })
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    setLoading(false)
                })
        },
        [year],
    )

    useEffect(() => getTableWeeks(), [getTableWeeks])

    return {
        stateWeeks,
        buttonCSV,
        listOfYears,
        updateYear,
        year,
        sectionMenu,
        handleSectionChange,
        columns,
        loading,
        onChangeTable,
        downloadCSV
    }
}

export default useTableWeeks